export default __webpack_public_path__ + "static/santa-photo-fb8a06c62418e0bebdce395ca1d7211e.jpg";